// Import Firebase core + auth
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber
} from "firebase/auth";

// Optional (remove if not using analytics)
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDHJOyjlOQVJhaMbVch7m_7WYjF6nR5d48",
    authDomain: "tetanapp-61ccb.firebaseapp.com",
    projectId: "tetanapp-61ccb",
    storageBucket: "tetanapp-61ccb.firebasestorage.app",
    messagingSenderId: "873219444971",
    appId: "1:873219444971:web:8679c77f06a77af49e2eae",
    measurementId: "G-CBSHLSJGJ5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Optional analytics
try {
  getAnalytics(app);
} catch (e) {
  console.warn("Analytics not supported in this environment");
}

// Export everything needed
export { auth, provider, RecaptchaVerifier, signInWithPhoneNumber };
